import React from 'react'

import { OverviewTableTemplateProps } from './interface'

export function withOverviewTableTemplate(
  Component: React.FC<OverviewTableTemplateProps>
) {
  function WithOverviewTableTemplate({ ...props }: OverviewTableTemplateProps) {
    const newProps = {
      ...props,
    }
    return <Component {...newProps} />
  }
  return WithOverviewTableTemplate
}
